import defaultLocale from "../../locale/en-US/index.js";
export default defaultLocale;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/_lib/defaultLocale/index.js
// module id = 95
// module chunks = 93